import React from "react";
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import ArrangementPane from './ArrangementPane'
import BreadCrumbsPage from './../../drive/cards/BreadCrumbs'
import { Tab, Label, Menu } from "semantic-ui-react";
import ReferenceTabs from "../../drive/cards/summaryTabs/ReferencesTab";
import AttachmentTabs from "../../drive/cards/summaryTabs/Attachments";
import NoteTabs from "../../drive/cards/summaryTabs/Notes";

import ContentImage from '../../../../../images/menu-icons/user/icon-contents.svg';
import AttachmentImage from '../../../../../images/menu-icons/user/icon-community.svg';
import NoteImage from '../../../../../images/menu-icons/user/icon-marketplace.svg';
import { Header, Image, Container } from "semantic-ui-react";

const NoSummaryData = (props) =>
    <Container fluid className="bg-light-blue" style={{ padding: "50px 0" }}  >
        <div style={{ padding: "30px", background: "#607d8b", borderRadius: "500em", width: "140px", height: "140px", margin: "0 auto" }}>
            <Image
                style={{ width: "80px" }}
                src={props.imageName}
                className="landingImage"
                centered={true} />
        </div>
        <Header
            as='h6'
            icon
            textAlign='center' >
            <Header.Content>
                No {props.type} To show !
        </Header.Content>
        </Header>
    </Container>

class SummaryView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
            data: []
        }
    }

    componentWillMount = async () => {
        await dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(this.props.match.params.playbookId);
        dispatch.app.setRouteParams(this.props.match.params);
        let payload = {
            id: this.props.match.params.playbookId
        }
        dispatch.lifeCycle.getActivitySummary(payload)
        dispatch.createPack.showDuplicateIcon(false);
        dispatch.lifeCycle.displaySecondMenu(null);
    }

    onTabChange = (event, data) => {
        this.setState({ activeIndex: data.activeIndex })
    }
    getUniqueAttachments = (data) => {
        const uniqueAttachmentsMap = new Map();
        if(data.attachments){
            for (const task of data.attachments) {
                for (const attachment of task.attachments) {
                const key = `${attachment.documentName}-${attachment.documentUrl}`;
                if (!uniqueAttachmentsMap.has(key)) {
                    uniqueAttachmentsMap.set(key, attachment);
                }
                }
            }
        }
        return Array.from(uniqueAttachmentsMap.values());
      }
    render() {

        const { loadingActivitySummary, activitySummary } = this.props

        let ref = activitySummary.counts && activitySummary.counts.totalRef ?
            activitySummary.counts.totalRef : 0

        let att = activitySummary.counts && activitySummary.counts.totalAtt ?
            activitySummary.counts.totalAtt : 0

        let note = activitySummary.counts && activitySummary.counts.totalNotes ?
            activitySummary.counts.totalNotes : 0
        const uniqueAttachments = this.getUniqueAttachments(activitySummary);

        const panes = [
            {
                menuItem:
                    <Menu.Item
                        key='References'>
                        References
                        <Label>{ref}</Label>
                    </Menu.Item>,
                render: () => ref !== 0 ?
                    <ReferenceTabs
                        loadingActivitySummary={loadingActivitySummary}
                        referencesData={activitySummary.references}
                        counts={activitySummary.counts}
                        user={this.props.user}
                        selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                        selectedPracticeFlowActivity={this.props.selectedPracticeFlowActivity}
                        selectedOrganisation={this.props.selectedOrganisation}
                    /> :
                    <NoSummaryData
                        type="References"
                        imageName={ContentImage}
                    />
            },
            {
                menuItem:
                    <Menu.Item key='Attachments'>
                        Attachments  <Label>  {att}  </Label>
                    </Menu.Item>,
                render: () => att !== 0 ?
                    <AttachmentTabs
                        loadingActivitySummary={loadingActivitySummary}
                        attachmentsData={activitySummary.attachments}
                        uniqueAttachments={uniqueAttachments}
                        uniqueAttachmentsCounts = {uniqueAttachments.length}
                        counts={activitySummary.counts}
                        totalAttachment={att}
                        {...this.props} /> :
                    <NoSummaryData type="Attachments" imageName={AttachmentImage} />
            },
            {
                menuItem:
                    <Menu.Item key='Comment' disabled>
                        Comment   <Label>  {note} </Label>
                    </Menu.Item>,
                render: () => note !== 0 ? <NoteTabs
                    loadingActivitySummary={loadingActivitySummary}
                    notesData={activitySummary.notes}
                    counts={activitySummary.counts}
                    totalNote={note} /> :
                    <NoSummaryData type="Comment" imageName={NoteImage} />
            }
        ]

        return (
            <div className="containerBox overflow-auto" onKeyDown={this.onKeyPressed} >
                <ArrangementPane {...this.props} setPage="Summary" />
                <BreadCrumbsPage {...this.props} />

                <Tab
                    className="three-block summary-view"
                    style={{ padding: 0, border: "1px solid #d4d4d5" }}
                    menu={{ secondary: true, pointing: true }}
                    panes={panes}
                    onTabChange={this.onTabChange}
                />


            </div>
        );
    }
}
export default withRouter(SummaryView);
